import React, {useEffect, useState} from 'react';
import {FiBookOpen, FiLogOut, FiMinus, FiPlus} from 'react-icons/fi';
import {Link, useHistory, useParams} from 'react-router-dom';
import {useToasts} from 'react-toast-notifications';

import api from '../../services/api';
import Dropzone from '../../components/Dropzone';
import configBackend from '../../config-backend';

import logo from '../../assets/fullLogo.png';
import './styles.css';
import {logout} from '../../auth/auth';
import DropzoneAudio from '../../components/DropzoneAudio';
import RecordAudio from '../../components/RecordAudio';
import {FaSpinner} from 'react-icons/fa';

export interface Mouths {
    id: number;
    image: string;
}

function CreateStory() {
    const {addToast} = useToasts();
    const {id} = useParams();

    const [mouths, setMouths] = useState<Mouths[]>([]);

    const [disableButton, setDisableButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [oldAudio, setOldAudio] = useState('');
    const [selectedAudio, setSelectedAudio] = useState<File>();
    const [oldImage, setOldImage] = useState('');
    const [mode, setMode] = useState('create');
    const [audioDuration, setAudioDuration] = useState(0);
    const [durationMouths, setDurationMouths] = useState(0);
    const [selectedFile, setSelectedFile] = useState<File>();
    const [mouthItems, setMouthItems] = useState([
        {mouth_id: 0, duration: 0}
    ]);

    const history = useHistory();

    useEffect(() => {
        api.get('/mouths').then((response) => {
            setMouths(response.data);
        });
    }, []);


    useEffect(() => {
        try {
            if (id) {
                api.get(`/stories/${id}`).then(response => {
                    setTitle(response.data.title);
                    setOldImage(response.data.image);
                    setOldAudio(response.data.audio);
                    setMouthItems(response.data.mouths);
                    setMode('edit')
                });
            }
        } catch (e) {
            addToast(e.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
            });
        }
    }, [id]);

    const updateDurationMouths = () => {
        const soma = mouthItems.reduce(function (acumulador, valorAtual) {
            return acumulador + valorAtual.duration;
        }, 0)
        if (soma > audioDuration && audioDuration != 0) {
            addToast('A duração das bocas deve ser menor ou igual à duração do áudio carregado', {
                appearance: 'error',
                autoDismiss: true,
            });
            setDisableButton(true);
            setDurationMouths(0);
        } else {
            setDisableButton(false);
            setDurationMouths((audioDuration - soma));
        }
    }

    function setMouthItemValue(position: number, field: string, value: string) {
        const updatedScheduleItems = mouthItems.map((scheduleItem, index) => {
            if (index === position) {
                return {...scheduleItem, [field]: Number(value)};
            }
            return scheduleItem;
        });

        setMouthItems(updatedScheduleItems);
    }

    useEffect(() => {
        updateDurationMouths();
    }, [audioDuration, mouthItems])

    function addMouthItem() {
        setMouthItems([
            ...mouthItems,
            {mouth_id: 0, duration: 0}
        ]);
    }

    function delMouthItem() {
        let mouths = [...mouthItems]
        mouths.pop()
        setMouthItems(mouths)
    }

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        setDisableButton(true);
        setLoading(true);
        const data = new FormData();
        data.append('title', title);
        data.append('mouths', JSON.stringify(mouthItems));

        if (selectedAudio)
            data.append('audio', selectedAudio);

        if (selectedFile) {
            data.append('image', selectedFile);
        }

        addToast('Aguarde enquanto os arquivos são processados', {
            appearance: 'info',
            autoDismiss: true
        });

        if (!id) {
            await api.post('stories', data).then(response => {
                addToast('História cadastrada com sucesso', {
                    appearance: 'success',
                    autoDismiss: true,
                })
                setTitle('');
                setMouthItems([
                    {mouth_id: 0, duration: 0}
                ]);
                setAudioDuration(0);
                setSelectedFile(undefined);
                setSelectedAudio(undefined);
                history.push('/list/story');
            }).catch(e => {
                addToast(e.response.data.message, {
                    appearance: 'error',
                    autoDismiss: true,
                })
            }).finally(() => {
                setDisableButton(false);
                setLoading(false);
            })
        } else {
            data.append('oldImage', oldImage);
            data.append('oldAudio', oldAudio);
            await api.put(`/stories/${id}`, data).then(response => {
                response.data.image && setOldImage(response.data.image);
                response.data.audio && setOldAudio(response.data.audio);
                addToast('História atualizada com sucesso', {
                    appearance: 'success',
                    autoDismiss: true,
                });
                history.push('/list/story');
            }).catch(e => {
                addToast(e.response.data.message, {
                    appearance: 'error',
                    autoDismiss: true,
                })
            }).finally(() => {
                setDisableButton(false);
                setLoading(false);
            })
        }
    }

    async function handleLogout() {
        logout();
        history.push('/');
    }

    const getDurationAudio = () => {
        if (audioDuration > 0) {
            if (audioDuration == 1) {
                return 'Duração aproximada do áudio carregado: ' + audioDuration + ' segundo.'
            } else {
                return 'Duração aproximada do áudio carregado: ' + audioDuration + ' segundos.'
            }
        }
    }

    const getInputMouths = () => {
        if (selectedAudio || oldAudio) {
            return <fieldset>
                <legend>
                    <h2>Bocas</h2>
                </legend>
                <ul className="items-grid">
                    {mouths.map((item, index) => (
                        <li key={item.image} className="mouths-image">
                            <img src={`${configBackend}/uploads/icons-mouths/${item.image}`} alt={item.image}
                                 width={120} height={70}/>
                            <span>{item.image}</span>
                        </li>
                    ))}
                </ul>
                {mouthItems.map((item, index) => {
                    return (
                        <div key={index.toString()}>
                            <div className="field">
                                <label>
                                    Selecione uma boca
                                </label>
                                <select onChange={e => setMouthItemValue(index, 'mouth_id', e.target.value)}
                                        value={item.mouth_id}>
                                    <option value="0">Selecione uma boca</option>
                                    {mouths.map((mouth, i) => (
                                        <option key={i.toString()} value={mouth.id}>{mouth.image}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="field">
                                <label htmlFor="audio">
                                    Informe a duração em segundos para a boca
                                </label>
                                <input type="number" placeholder="Segundos"
                                       value={item.duration === 0 ? '' : item.duration}
                                       onChange={e => {
                                           let valor: number = Number(e.target.value)
                                           if (valor >= 0) {
                                               setMouthItemValue(index, 'duration', e.target.value)
                                           } else {
                                               setMouthItemValue(index, 'duration', '')
                                           }
                                       }
                                       }/>
                            </div>
                        </div>
                    );
                })}
            </fieldset>
        }
    }

    const getButtonsMouths = () => {
        if (selectedAudio || oldAudio) {
            return <div className={'buttons'}>
                <button type="button" id="add-button" onClick={addMouthItem}><FiPlus size={24}/></button>
                {getRemainingDurationMouths()}
                {mouthItems.length > 1 &&
                <button type="button" id="add-button" onClick={delMouthItem}><FiMinus size={24}/></button>}
            </div>
        }
    }

    const getRemainingDurationMouths = () => {
        if (durationMouths > 0) {
            if (durationMouths == 1) {
                return <div>Resta {durationMouths} segundo</div>
            } else {
                return <div>Restam {durationMouths} segundos</div>
            }
        }
    }

    return (
        <div id="page-create-point">
            <header className={'menu'}>
                <img src={logo} alt="Miaw" width={136}/>
                <nav id="menu">
                    <Link to="/list/story">
                        <FiBookOpen/>
                        Minhas histórias
                    </Link>
                    <a href="#" rel="noopener noreferrer" onClick={handleLogout}>
                        <FiLogOut/>
                        Sair
                    </a>
                </nav>
            </header>
            <form onSubmit={handleSubmit}>
                <h1>{mode === 'edit' ? 'Edite a história' : 'Crie uma nova história'}</h1>
                <fieldset>
                    <legend>
                        <h2>Ícone da história</h2>
                    </legend>
                    <Dropzone onFileUploaded={setSelectedFile} selectedFile={selectedFile}
                              mode={mode}
                              currentUrl={`${configBackend}/uploads/${oldImage}`}/>
                </fieldset>
                <fieldset>
                    <legend>
                        <h2>Áudio da história</h2>
                    </legend>
                    <div className="field">
                        <label>
                            Faça upload do áudio. Deve estar no formato mp3 ou m4a.
                        </label>
                        <DropzoneAudio onFileUploaded={setSelectedAudio} selectedFile={selectedAudio}
                                       currentUrl={`${configBackend}/uploads/${oldAudio}`}/>
                        <RecordAudio onFileUploaded={setSelectedAudio} selectedFile={selectedAudio}
                                     setAudioDuration={setAudioDuration}
                                     currentUrl={oldAudio}/>
                        {getDurationAudio()}
                    </div>
                </fieldset>
                <fieldset>
                    <legend>
                        <h2>Dados</h2>
                    </legend>
                    <div className="field">
                        <label htmlFor="title">
                            Título da história
                        </label>
                        <input
                            type="text"
                            placeholder="Digite o título da história..."
                            id="title"
                            value={title}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.currentTarget.value)}
                        />
                    </div>
                </fieldset>
                {getInputMouths()}
                {getButtonsMouths()}
                {disableButton && loading ? (
                    <div style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: 8
                    }}>
                        <div className="spinner">
                            <i><FaSpinner className="fa-spin" size={48}/></i>
                        </div>
                        <p>Salvando história.</p>
                    </div>
                ) : (
                    <button type="submit" disabled={disableButton}>Salvar</button>
                )}
            </form>
        </div>
    );
}

export default CreateStory;
